import React from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import moment from 'moment';
import 'moment/locale/es';


function createData(status, openDate, openMount, closeDate, closeMount, total, user) {
  return { status, openDate, openMount, closeDate, closeMount, total, user };
}

const rows = [
  createData( false, moment().format('DD/MM/YYYY'), 80, moment().format('DD/MM/YYYY'), 80, 160, 'admin' ),
];


const DailySummary = () => {
  return (
    <>
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                <TableRow>
                    <TableCell>Estado de caja</TableCell>
                    <TableCell>Fecha apertura</TableCell>
                    <TableCell>Monto apertura</TableCell>
                    <TableCell>Fecha cierre</TableCell>
                    <TableCell>Monto cierre</TableCell>
                    <TableCell>Total</TableCell>
                    <TableCell>Responsable</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {rows.map((row) => (
                    <TableRow
                    key={row.code}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                    <TableCell component="th" scope="row">{
                        (row.status) ? 'Abierta' : 'Cerrada'
                    }</TableCell>
                    <TableCell>{row.openDate}</TableCell>
                    <TableCell>{row.openMount}</TableCell>
                    <TableCell>{row.closeDate}</TableCell>
                    <TableCell>{row.closeMount}</TableCell>
                    <TableCell>{row.total}</TableCell>
                    <TableCell>{row.user}</TableCell>
                    </TableRow>
                ))}
                </TableBody>
            </Table>
        </TableContainer>
    </>
  )
}

export default DailySummary